import { call } from "./api";

const b64ToUint8 = (s: string) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4); const b = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(Array.from(b).map(c => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

/** ثبت Service Worker (بی‌صدا). اشتراک Push فقط با اجازه کاربر ساخته می‌شود. */
export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); } catch { return null; }
}

export async function enablePush(): Promise<{ ok: boolean; message?: string }> {
  if (!pushSupported()) return { ok: false, message: "مرورگر شما از اعلان پشتیبانی نمی‌کند" };
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, message: "اجازه اعلان داده نشد" };
  const reg = (await registerSW()) || (await navigator.serviceWorker.ready);
  const k = await call("vapid_key");
  if (!k.key) return { ok: false, message: "کلید Push روی سرور تنظیم نشده است" };
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(k.key) });
  const r = await call("push_subscribe", { subscription: sub.toJSON() });
  return { ok: !!r.success, message: r.message };
}

export async function pushActive(): Promise<boolean> {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration();
  return !!(await reg?.pushManager.getSubscription());
}

/** صدای کوتاه اعلان (بدون فایل صوتی) */
let actx: AudioContext | null = null;
export function beep(kind: "msg" | "notify" = "msg") {
  try {
    actx = actx || new (window.AudioContext || (window as any).webkitAudioContext)();
    const t = actx.currentTime; const o = actx.createOscillator(); const g = actx.createGain();
    o.type = "sine"; o.frequency.setValueAtTime(kind === "msg" ? 740 : 880, t); o.frequency.exponentialRampToValueAtTime(kind === "msg" ? 980 : 1175, t + 0.12);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.12, t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
    o.connect(g).connect(actx.destination); o.start(t); o.stop(t + 0.3);
  } catch { /* بی‌صدا */ }
}
